<template>
      <div id="therapist">
            <section class="section derm-hero animate__animated animate__fadeIn">
                  <BackButton link="/livehealth-online" />
                  <div class="grid-container max">
                        <div class="derm-intro">
                              <h1>Connect with a<br />licensed therapist,<br />anytime anywhere</h1>
                              <p class="derm-subtitle">It&rsquo;s easy and convenient using LiveHealth Online</p>
                              <p class="derm-desc">Getting mental health support is simple with LiveHealth Online. Schedule an appointment and connect with a licensed therapist or psychiatrist from the privacy of home&mdash;all you need is your smartphone, tablet, or computer.</p>
                        </div>
                        <div class="derm-box">
                              <div class="derm-box-steps">
                                    <h3>Visit a licensed therapist in 3 easy steps</h3>
                                    <div class="derm-steps-grid">
                                          <div class="derm-step">
                                                <div class="derm-step-marker"><span>1</span></div>
                                                <h5>Find the right provider</h5>
                                                <p>Browse mental health professionals, review their experience and approach, and choose one that fits your needs.</p>
                                          </div>
                                          <div class="derm-step">
                                                <div class="derm-step-marker"><span>2</span></div>
                                                <h5>Schedule your private appointment</h5>
                                                <p>Flexible options are available weekdays, evenings, and weekends, with sessions typically lasting 45 minutes.</p>
                                          </div>
                                          <div class="derm-step">
                                                <div class="derm-step-marker"><span>3</span></div>
                                                <h5>Meet with your provider</h5>
                                                <p>Discuss your concerns, symptoms, and care plan in a secure, one-on-one video session.</p>
                                          </div>
                                    </div>
                              </div>
                              <div class="derm-box-concerns">
                                    <h3>Use LiveHealth Online for mental health concerns like these:</h3>
                                    <div class="derm-concerns-grid">
                                          <ul>
                                                <li>Anxiety</li>
                                                <li>Stress management</li>
                                                <li>Obsessive-compulsive disorder</li>
                                                <li>Panic attacks</li>
                                          </ul>
                                          <ul>
                                                <li>PTSD/trauma</li>
                                                <li>Insomnia</li>
                                                <li>Depression</li>
                                                <li>Life transitions</li>
                                          </ul>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <div class="derm-btn-wrap">
                  <router-link to="/total-health" class="derm-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPTherapist",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#therapist {
      .derm-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .derm-intro {
                  max-width: 780px;
                  margin: 48px 0 40px 0;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 24px;
                  }

                  .derm-subtitle {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        margin-bottom: 16px;
                  }

                  .derm-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 0;
                  }
            }

            .derm-box {
                  display: flex;
                  flex-wrap: wrap;
            }

            .derm-box-steps {
                  flex: 2 1 640px;
                  background-color: #1355E9;
                  padding: 48px;

                  h3 {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 1.25rem;
                        margin-bottom: 32px;
                  }
            }

            .derm-steps-grid {
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 32px;
            }

            .derm-step {
                  .derm-step-marker {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        border: solid 2px #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 0.875rem;
                        margin-bottom: 16px;
                  }

                  h5 {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 1.0625rem;
                        margin-bottom: 6px;
                  }

                  p {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 0.9375rem;
                        line-height: 1.5;
                        margin-bottom: 0;
                  }
            }

            .derm-box-concerns {
                  flex: 1 1 320px;
                  background-color: #0A2C4C;
                  padding: 48px;

                  h3 {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 1.25rem;
                        line-height: 1.3;
                        margin-bottom: 24px;
                  }
            }

            .derm-concerns-grid {
                  display: grid;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 8px 16px;

                  ul {
                        margin: 0;
                        padding: 0;
                        list-style: none;
                  }

                  li {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 0.9375rem;
                        line-height: 1.9;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .derm-intro {
                        margin: 32px 0;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .derm-box-steps,
                  .derm-box-concerns {
                        padding: 32px 24px;
                  }

                  .derm-steps-grid {
                        grid-template-columns: 1fr;
                        gap: 24px;
                  }

                  .derm-concerns-grid {
                        grid-template-columns: 1fr;
                  }
            }
      }

      .derm-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .derm-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }
}
</style>
